import React from 'react';
import { Divider } from 'antd';
import styled from 'styled-components';

import TemplateItem from './TemplateItem';

const StyledDivider = styled(Divider)`
  margin: 0;
`;

const TemplateList = ({
  templates,
  idUsingTemplate,
  description,
  onUpdate,
  onCreate,
  onToggle,
  onDelete,
}) =>
  templates.map((template) => (
    <div key={template.id}>
      <TemplateItem
        key={template.id}
        template={template}
        idUsingTemplate={idUsingTemplate}
        onUpdate={(name) => onUpdate(name, description)}
        onCreate={(name) => onCreate(name, description)}
        onToggle={(templateParam) => onToggle(templateParam)}
        onDelete={(id) => onDelete(id)}
      />
      <StyledDivider />
    </div>
  ));

export default TemplateList;
